import type { ReactNode } from "react";

/**
 * A Telegram-style grouped card: a white rounded block with an optional blue
 * header inside it and an optional muted caption below it. See
 * `docs/telegram-ui.md`.
 */
export default function Section({
  title,
  footer,
  error = false,
  children,
}: {
  title?: ReactNode;
  footer?: ReactNode;
  /** Draws a danger outline around the card to flag a validation error. */
  error?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="mt-3">
      <div
        className={`mx-3 overflow-hidden rounded-2xl bg-background transition-shadow ${
          error ? "ring-1 ring-danger" : ""
        }`}
      >
        {title ? (
          <p
            className="px-4 pb-1 pt-3 text-xs font-semibold text-primary"
            dir="rtl"
          >
            {title}
          </p>
        ) : null}
        {children}
      </div>
      {footer ? (
        <p className="mx-5 mt-2 text-xxs leading-5 text-default-500" dir="rtl">
          {footer}
        </p>
      ) : null}
    </div>
  );
}
